import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getProviderQueryOptions, getProvidersQueryOptions } from "./get.hooks";

export function useDeleteProvider(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/providers/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(getProvidersQueryOptions.queryKey, (old) =>
        old?.filter((p) => p.id !== id),
      );
      queryClient.resetQueries({
        queryKey: getProviderQueryOptions(id).queryKey,
      });
      toast({
        title: "toast.providerDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteProviderError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
